import React from "react";
import { useSelector } from "react-redux";

import * as HeaderSelectors from "@redux/modules/value/header/header.selectors";
import * as ProfileSidebarModule from "@redux/modules/value/profileSidebar/profileSidebar.module";
import { useThunkDispatch } from "@redux/dispatcher";

import ProfileMenuButton from "./profileMenuButton.component";

const ProfileMenuButtonContainer = () => {
    const dispatch = useThunkDispatch();
    const header = useSelector(HeaderSelectors.getHeader);

    return (
        <ProfileMenuButton
            handleClick={() => {
                if (!header?.sidebarActive) {
                    dispatch(
                        ProfileSidebarModule.update({
                            active: true,
                        }),
                    );
                }
            }}
        />
    );
};

export { ProfileMenuButtonContainer };
